import React from 'react';
import Text from 'Components/Text';

export default ({isReadAcrossFormula, baseOilNumber, isPaid}) => {
  return (
    <section className='scene_section'>
      <header>Formulation</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _width_pc_36 _margin_right_30'
        textClassName='text__text_primary'
        label='Formulation Type'
        value={isReadAcrossFormula ? 'Read Across Formulation' : 'Base Formulation'}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary _width_pc_36 _margin_right_30'
        textClassName='text__text_primary'
        label='Base Oil Number'
        value={baseOilNumber}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary _width_90'
        textClassName={`text__binary-status-text ${isPaid ? 'true' : 'false'}`}
        label='Payment Status'
        value={isPaid ? 'Paid' : 'Unpaid'}
      />
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Details/FormulaTypeSection.jsx